import { motion } from "framer-motion";

function formatContent(text = "") {
  // Light markdown: paragraphs + simple bullet points.
  const lines = text.split(/\r?\n/);
  const blocks = [];
  let listBuffer = [];

  const flushList = () => {
    if (listBuffer.length) {
      blocks.push({ type: "list", items: [...listBuffer] });
      listBuffer = [];
    }
  };

  lines.forEach((line) => {
    const m = line.match(/^\s*(?:[-•*]|\d+\.)\s+(.*)$/);
    if (m) {
      listBuffer.push(m[1]);
    } else if (line.trim() === "") {
      flushList();
    } else {
      flushList();
      blocks.push({ type: "p", text: line });
    }
  });
  flushList();
  return blocks;
}

export default function ChatMessage({ message, idx }) {
  const isUser = message.role === "user";
  const blocks = formatContent(message.content);

  return (
    <motion.div
      initial={{ opacity: 0, y: 8 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.3, delay: Math.min(idx * 0.02, 0.2) }}
      className={`flex w-full ${isUser ? "justify-end" : "justify-start"}`}
      data-testid={`chat-message-${message.role}-${idx}`}
    >
      <div
        className={`max-w-[88%] rounded-2xl px-4 py-3 text-sm leading-relaxed ${
          isUser
            ? "rounded-br-md bg-[color:var(--sentinel)] text-white"
            : "rounded-bl-md bg-zinc-100 text-zinc-900"
        }`}
      >
        {blocks.map((b, i) =>
          b.type === "list" ? (
            <ul key={i} className="my-1 space-y-1 pl-1">
              {b.items.map((it, j) => (
                <li key={j} className="flex items-start gap-2">
                  <span
                    className={`mt-2 inline-block h-1 w-1 shrink-0 rounded-full ${
                      isUser ? "bg-white/80" : "bg-[color:var(--sentinel)]"
                    }`}
                  />
                  <span>{it}</span>
                </li>
              ))}
            </ul>
          ) : (
            <p key={i} className="whitespace-pre-wrap break-words">
              {b.text}
            </p>
          )
        )}
      </div>
    </motion.div>
  );
}

export function ChatTypingIndicator() {
  return (
    <div className="flex justify-start" data-testid="chat-thinking">
      <div className="inline-flex items-center gap-1.5 rounded-2xl rounded-bl-md bg-zinc-100 px-4 py-3 text-sm text-zinc-900">
        {[0, 1, 2].map((i) => (
          <motion.span
            key={i}
            className="inline-block h-1.5 w-1.5 rounded-full bg-[color:var(--sentinel)]"
            animate={{ y: [0, -4, 0], opacity: [0.4, 1, 0.4] }}
            transition={{ duration: 0.9, repeat: Infinity, delay: i * 0.15 }}
          />
        ))}
      </div>
    </div>
  );
}
